import { addItem, empty, removeItem, selectItems, setItems, updateItemQty } from "./cartSlice";
import { hidePrices, selectShowPrices, showPrices } from "./configSlice";
import store from "./store";

const setCartItems = (cartItems) => store.dispatch(setItems(cartItems));
const addItemToCart = (item) => store.dispatch(addItem(item));
const removeItemFromCart = (index, quantity) => store.dispatch(removeItem({ index, quantity }));
const emptyCart = () => store.dispatch(empty());
const updateCartItemQty = (index, quantity) => store.dispatch(updateItemQty({ index, quantity }));

const selectItemsFromCart = () => {
  const state = store.getState();
  return selectItems(state);
}

const selectConfigShowPrices = () => {
  const state = store.getState();
  return selectShowPrices(state);
}

const configShowPrices = () => store.dispatch(showPrices())
const configHidePrices = () => store.dispatch(hidePrices())

export {
  setCartItems,
  addItemToCart,
  removeItemFromCart,
  emptyCart,
  updateCartItemQty,
  selectItemsFromCart,
  selectConfigShowPrices,
  configShowPrices,
  configHidePrices
}